import { ShowToast } from "@Components/ToastNotification/ToastNotification"
import { baseColors } from "@Constants/baseStyles"
import { PostCategories } from "@Constants/constant"
import { EducatifDiagnoseService } from "@Services/EducatifDiagnose.Service"
import { PostService } from "@Services/Posts"

const fetchAllCategories = ({ setLoading, setCategories }) => {
    setLoading(true)
    PostService.getCategories()
        .then((response) => {
            const data = response.data.data?.items
            if (data) {
                setCategories(data)
            }
            setLoading(false)
        })
        .catch((e) => {
            ShowToast({ type: "error", message: "Une erreur est survenue lors de la récuperation des categories" })
            setLoading(false)
        })
}

const fetchAllAxis = ({ setLoading, setDiagnosis }) => {
    setLoading(true)
    EducatifDiagnoseService.getAllAxis()
        .then((response) => {
            const data = response.data.data?.items
            if (data && data instanceof Array) {
                setDiagnosis(data.slice(0, data.length - 3))
            }
            setLoading(false)
        })
        .catch((e) => {
            ShowToast({ type: "error", message: "Une erreur est survenue lors de la récuperation des axes" })
            setLoading(false)
        })
}

const knowledges = [
    {
        id: 1,
        title: "Savoir",
        bgColor: "#3CA5A5",
        screen: "Savoirs",
        code: PostCategories.knowledge,
        flex: 1.2 / 5
    },
    {
        id: 2,
        title: "Savoir-Faire",
        bgColor: "#41B4B4",
        screen: "SavoirFaire",
        code: PostCategories.knowHow,
        flex: 1.8 / 5
    },
    {
        id: 3,
        title: "Savoir-Être",
        bgColor: baseColors.green.pastel,
        screen: "SavoirEtre",
        code: PostCategories.knowHowToBe,
        flex: 1.8 / 5
    }
]

export { knowledges, fetchAllCategories, fetchAllAxis }
